import React from 'react';

const AgentsPage: React.FC = () => {
  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Agents</h2>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg p-6">
        <p className="text-gray-600">Agent fleet management and monitoring</p>
        <p className="text-sm text-gray-500 mt-2">
          View agent health, assign tasks, and monitor performance
        </p>
      </div>
    </div>
  );
};

export default AgentsPage;
